<template>
  <div class="date-picker-seven-day -mx-5 max-w-100dvw">
    <div class="flex justify-between items-center px-4 pt-2 pb-4">
      <template v-for="(item, i) in weekDays" :key="item.date">
        <div class="flex flex-col items-center gap-2">
          <div class="text-sm text-gray-80 py-1">{{ item.weekDay }}</div>
          <nd-button
            type="text"
            class="!rounded-full w-8 h-8 !p-1.5"
            :class="{ selected: item.selected, '!text-yellow-50': !i }"
            :disabled="item.disabled"
            @click="handleDayButtonClick(item.date)"
          >
            {{ item.day }}
          </nd-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { addDays } from 'date-fns'

import { getUtcDate } from '@/utils/time'
import type { FbranchArrivaltimeInfo } from '@/types/api'

const selectedDate = defineModel<string>()

const props = defineProps<{
  arrivalTimes: FbranchArrivaltimeInfo
}>()

const { formatInTimeZone } = await useI18nDateFns()

const timezone = computed(() => props.arrivalTimes.timezone || 'Asia/Taipei')

const firstAvailableDate = computed(() => {
  const _firstDate = props.arrivalTimes.selldates ? Object.keys(props.arrivalTimes.selldates)?.[0] : props.arrivalTimes.start_day
  return getUtcDate(_firstDate, props.arrivalTimes.timezone)
})

const weekDays = computed(() => {
  return Array.from({ length: 7 }, (_, i) => {
    const date = addDays(firstAvailableDate.value, i)
    const formattedDate = formatInTimeZone(date, timezone.value, 'yyyy-MM-dd')
    return {
      date: formattedDate,
      day: formatInTimeZone(date, timezone.value, 'd'),
      weekDay: formatInTimeZone(date, timezone.value, 'iii'),
      disabled: !props.arrivalTimes?.selldates?.[formattedDate],
      selected: selectedDate.value === formattedDate,
    }
  })
})

const handleDayButtonClick = (date: string) => {
  if (weekDays.value.find(item => item.date === date)?.disabled) return
  selectedDate.value = date
}
</script>

<style lang="scss" scoped>
.date-picker-seven-day {
  .selected {
    @apply !bg-yellow-50 !text-white;
  }
}
</style>
